import { useAuth } from "@bw/shared/hooks";
import { AuthShell, AuthStartupPending } from "../components/AuthShell";
import { LoginForm } from "../components/LoginForm";
import { useAuthedRedirect } from "../useAuthedRedirect";
import { useDocumentTitle } from "../useDocumentTitle";

/**
 * Sign-in page (owner/admin). Ported from business-v2 `(auth)/sign-in/page.tsx`.
 * `useAuthedRedirect` bounces an already-authenticated visitor to `?next=` or
 * `/dashboard` instead of showing the form (no login loop).
 */
export function SignInPage() {
  useDocumentTitle("Sign in · Badminton Warriors");
  const { loading } = useAuth();
  useAuthedRedirect();
  return (
    <AuthShell title="Sign in to your account">
      {loading ? (
        <AuthStartupPending />
      ) : (
        <LoginForm />
      )}
    </AuthShell>
  );
}
